import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";

const NAMES = ["Rafael", "Juliana", "Diego", "Camila", "Lucas", "Amanda", "Bruno", "Patrícia", "Thiago", "Larissa", "Felipe", "Beatriz", "Gustavo", "Marina", "André", "Carolina"];
const CITIES = ["São Paulo, SP", "Rio de Janeiro, RJ", "Belo Horizonte, MG", "Curitiba, PR", "Porto Alegre, RS", "Salvador, BA", "Fortaleza, CE", "Brasília, DF", "Recife, PE", "Goiânia, GO", "Campinas, SP", "Florianópolis, SC"];

const rnd = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function LiveBuyers() {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    let timer;
    const show = () => {
      setPopup({ id: Date.now(), name: rnd(NAMES), city: rnd(CITIES), mins: Math.floor(Math.random() * 9) + 1 });
      const hide = setTimeout(() => setPopup(null), 5000);
      timer = setTimeout(show, 9000 + Math.random() * 7000);
      return () => clearTimeout(hide);
    };
    const first = setTimeout(show, 4000);
    return () => { clearTimeout(first); clearTimeout(timer); };
  }, []);

  return (
    <div className="fixed left-4 bottom-4 z-[55] max-w-[86vw]" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <AnimatePresence>
        {popup && (
          <motion.div
            key={popup.id}
            initial={{ opacity: 0, y: 20, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.35 }}
            data-testid="live-buyer-popup"
            className="flex items-center gap-3 rounded-2xl border border-[#C8A46A]/30 bg-[#0F0F10]/95 backdrop-blur px-4 py-3 shadow-2xl"
          >
            <span className="w-9 h-9 rounded-full bg-[#C8A46A]/15 flex items-center justify-center shrink-0">
              <ShoppingBag className="w-4 h-4 text-[#C8A46A]" />
            </span>
            <div className="leading-tight">
              <p className="text-[#F5F1E8] text-sm font-medium">{popup.name} acabou de garantir sua análise</p>
              <p className="text-[#F5F1E8]/50 text-xs">{popup.city} · há {popup.mins} min</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export function LiveNowBadge() {
  const [count, setCount] = useState(23);
  useEffect(() => {
    const t = setInterval(() => {
      setCount((c) => {
        const delta = (Math.random() > 0.5 ? 1 : -1) * (Math.floor(Math.random() * 3) + 1);
        return Math.min(48, Math.max(12, c + delta));
      });
    }, 3500);
    return () => clearInterval(t);
  }, []);
  return (
    <span data-testid="live-now-badge" className="inline-flex items-center gap-2 text-sm text-[#F5F1E8]/70">
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-60 animate-ping" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
      </span>
      <strong className="text-[#F5F1E8] font-semibold">{count} pessoas</strong> analisando o visual agora
    </span>
  );
}
